import { type QueryOptions } from '@tanstack/query-core'

import { type WeightDisplaySettingEntity } from '@/libs/api'

import {
  fetchWeightDisplaySetting,
  type DcsWeightDisplaySettingQuery
} from '../api'
import { dcsQueryKeys } from '../query-keys'

export const getWeightDisplaySettingOptions = (
  tenantKey: string,
  dcId: number
): Required<
  Pick<QueryOptions<WeightDisplaySettingEntity>, 'queryKey' | 'queryFn'>
> => {
  const query: DcsWeightDisplaySettingQuery = {
    dcId,
    tenantKey
  }
  return {
    queryKey: dcsQueryKeys.weightDisplaySetting(tenantKey, dcId),
    queryFn: async ({ signal }) => {
      return await fetchWeightDisplaySetting(query, signal)
    }
  }
}
